type Props = {
  className?: string;
};

const IconDropDown = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3 6L8.29289 11.2929C8.68342 11.6834 9.31658 11.6834 9.70711 11.2929L15 6"
      stroke="#74797B"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default IconDropDown;
